// eslint-disable-next-line import/prefer-default-export
export function isValidString(value) {
  if (!value) {
    return true;
  }
  return /^[A-zÀ-ÿ0-9\- ']*$/.test(value);
}
